const FREE_MAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'msn.com',
  'yahoo.com',
  'yahoo.co.uk',
  'ymail.com',
  'icloud.com',
  'me.com',
  'mac.com',
  'aol.com',
  'protonmail.com',
  'proton.me',
  'pm.me',
  'gmx.com',
  'gmx.de',
  'mail.com',
  'fastmail.com',
  'zoho.com',
  'tutanota.com',
  'seznam.cz',
  'centrum.cz',
  'volny.cz',
  'post.cz',
  'atlas.cz',
  'email.cz',
]);

const PUBLIC_SUFFIXES = new Set([
  'co.uk',
  'co.jp',
  'co.in',
  'co.nz',
  'co.za',
  'com.au',
  'com.br',
  'ac.uk',
]);

function titleCase(label: string): string {
  return label
    .split(/[-_]/)
    .filter(Boolean)
    .map((part) => part[0].toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

export function emailDomain(email: string | undefined): string | undefined {
  if (!email) return undefined;
  const at = email.lastIndexOf('@');
  if (at < 0 || at === email.length - 1) return undefined;
  return email.slice(at + 1).trim().toLowerCase();
}

export function isFreeMailDomain(domain: string | undefined): boolean {
  if (!domain) return false;
  return FREE_MAIL_DOMAINS.has(domain);
}

export function organizationFromEmail(email: string | undefined): string | undefined {
  const domain = emailDomain(email);
  if (!domain || isFreeMailDomain(domain)) return undefined;
  const parts = domain.split('.');
  if (parts.length < 2) return undefined;
  const lastTwo = parts.slice(-2).join('.');
  const primary = PUBLIC_SUFFIXES.has(lastTwo) ? parts.at(-3) : parts.at(-2);
  if (!primary) return undefined;
  return titleCase(primary);
}
